module.exports = __webpack_public_path__ + "static/lottery-logo-100x93-42d714ca140c2990a77dffca7dbdb1e1.png";